import React from "react";
import { useTheme } from "../hooks/useTheme";

interface ActionButtonProps {
    className?: string,
    onClick?: () => void,
    children?: React.ReactNode,
    loading?: boolean,
    disabled?: boolean
}

export default function ActionButton(props: ActionButtonProps) {

    const { theme } = useTheme();

    const buttonStyle = { 
        backgroundColor: theme.color.primary, 
        color: theme.color.primaryAccent 
    };

    return (
        <button className={`action ${props.className}`} onClick={props.onClick} style={buttonStyle} disabled={props.loading || props.disabled}>
            {props.children}
        </button>
    )
}